
// Angular
import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReactiveFormsHelperService } from '@app/core/services/reactive-forms-helper.service';
// 3rdparty
import { TranslateService } from '@ngx-translate/core';
// Hostware
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { DataLocalizerComponent } from '@app/kip/components/data-localizer/data-localizer.component';
import { MaintenanceTask } from '@app/kip/dto/MaintenanceTask';
import { MaintenanceTaskService } from '@app/kip/services/maintenance-task.service';
import { EquipmentCache } from '@app/kip/dto/EquipmentCache';
import { Subscription } from 'rxjs';
import { EquipmentCacheService } from '@app/kip/services/equipment-cache.service';
import { RequestResult } from '@app/core/dto/RequestResult';

@Component({
  selector: 'maintenance-task-editor-dialog',
  templateUrl: './maintenance-task-editor-dialog.component.html',
  styleUrls: ['./maintenance-task-editor-dialog.component.scss']
})
export class MaintenanceTaskEditorDialogComponent implements OnInit, OnDestroy {


  @ViewChild('localizer') localizer: DataLocalizerComponent;
  editorForm: FormGroup;
  _data: MaintenanceTask;
  equipments: EquipmentCache[] = [];
  loadEquipments$: Subscription;



  constructor(public dialogRef: MatDialogRef<MaintenanceTaskEditorDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: MaintenanceTask,
    private sessionStorageService: SessionStorageService,
    private rfHelperService: ReactiveFormsHelperService,
    private maintenanceTaskService: MaintenanceTaskService,
    private equipmentCacheService: EquipmentCacheService,

    private translate: TranslateService,
    private fb: FormBuilder) {

    this.editorForm = this.fb.group({
      TaskCode: ['', [Validators.required, Validators.maxLength(10)]],
      TaskName: ['', [Validators.required, Validators.maxLength(40)]],
      EquipmentName : [this.translate.instant("common.not_set")],
      TimeLimit: 0,
      Active: true
    });
    this._data = data;
    if (!this._data.EquipmentName) {
      this._data.EquipmentName = this.translate.instant("common.not_set");
    }
  }

  //#region =============== Angular Lifecyle events ============================================================================

  ngOnInit() {
    this.rfHelperService.fillFormFromRecord(this._data, this.editorForm);

    this.loadEquipments$ = this.equipmentCacheService.loadAll(this.sessionStorageService.getSelectedUnit(), this.sessionStorageService.getSelectedHotelId()).subscribe(result => {
      const res = result as RequestResult;
      this.equipments = (res.Data as Array<EquipmentCache>).filter(f => f.EquipmentKind === 'M' || f.EquipmentKind === 'K');
      const emptyEquipment = new EquipmentCache();
      emptyEquipment.EquipmentId = -1;
      emptyEquipment.EquipmentName = this.translate.instant("common.not_set");
      emptyEquipment.EszNum = -1;
      this.equipments.splice(0, 0, emptyEquipment);
      this.rfHelperService.fillFormFromRecord(this._data, this.editorForm);
    })


  }

  ngOnDestroy(): void {

    this.loadEquipments$?.unsubscribe();
  }
  //#endregion =================================================================================================================

  //#region =============== List event hadlers   ===============================================================================
  //#endregion =================================================================================================================

  //#region =============== Form events ========================================================================================
  submit() {
    //this.rfHelperService.updateRecordFromForm(this._data,this.editorForm);

    this._data.SData = this.localizer.jsonData;
    this._data.Active = this.editorForm.controls["Active"].value;
    this._data.TaskCode = this.editorForm.controls["TaskCode"].value;
    this._data.TaskName = this.editorForm.controls["TaskName"].value;
    this._data.TimeLimit = this.editorForm.controls["TimeLimit"].value
    this._data.EquipmentName = this.editorForm.controls["EquipmentName"].value;
    this.dialogRef.close(this._data);
  }

  cancel() {
    this.dialogRef.close(undefined);
  }
  //#endregion =================================================================================================================

  //#region =============== Dialog events ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Validation    ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Functions  =========================================================================================
  title(): string {
    return this._data.TaskId === 0 ? this.translate.instant("common.adding_new_task") : this.translate.instant("common.change_task")

  }
  //#endregion =================================================================================================================


}
